import { render, staticRenderFns } from "./ChooseChannelModal.vue?vue&type=template&id=073acf29&scoped=true&"
import script from "./ChooseChannelModal.vue?vue&type=script&lang=js&"
export * from "./ChooseChannelModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseChannelModal.vue?vue&type=style&index=0&id=073acf29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073acf29",
  null
  
)

export default component.exports